interface IProps {
    color?: string;
}
export const EditIcon = (props: IProps) => {
    const { color } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="9"
            viewBox="0 0 10 9"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.6882 8.51395L8.08139 2.83272C8.32015 2.52635 8.40504 2.17215 8.32546 1.81149C8.25648 1.48363 8.05486 1.17189 7.75243 0.935392L7.01493 0.349532C6.37293 -0.16108 5.57706 -0.107332 5.12076 0.478529L4.62732 1.11867C4.56365 1.19876 4.57957 1.31701 4.65916 1.38151C4.65916 1.38151 5.90602 2.38123 5.93255 2.40273C6.01744 2.48335 6.08111 2.59085 6.09703 2.71985C6.12356 2.97247 5.94846 3.20896 5.68848 3.24121C5.56645 3.25733 5.44972 3.21971 5.36483 3.14984L4.0543 2.10711C3.99063 2.05928 3.89512 2.06949 3.84207 2.13399L0.727569 6.16514C0.525949 6.41775 0.456974 6.74562 0.525949 7.06274L0.923883 8.78807C0.945106 8.87944 1.02469 8.94394 1.1202 8.94394L2.87111 8.92244C3.18945 8.91707 3.48658 8.77194 3.6882 8.51395ZM6.13984 7.97663H8.99489C9.27344 7.97663 9.5 8.20613 9.5 8.48831C9.5 8.77103 9.27344 9 8.99489 9H6.13984C5.86129 9 5.63473 8.77103 5.63473 8.48831C5.63473 8.20613 5.86129 7.97663 6.13984 7.97663Z"
                fill={color || "#3293DC"}
            />
        </svg>
    );
};
